module.exports = __webpack_public_path__ + "static/img/fefco215_1.0c5f4da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco215_1.png
// module id = 7aJQ
// module chunks = 0